import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_CASE_INTERVAL_QUERY_KEY } from "../types/CommonTypes";
import { GET_CASE_INTERVAL_RESPONSE } from "../types/ResponseTypes";

async function getCaseInterval(
  tenantId: string,
  hospitalId: string,
  queryString: string
): Promise<GET_CASE_INTERVAL_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/case-intervals?${queryString}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });

  return data;
}

export default function useGetCaseIntervalQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [GET_CASE_INTERVAL_QUERY_KEY, queryString, tenantId, hospitalId],
    queryFn: () => getCaseInterval(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}
